import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';  // Make sure you have this import

const DonutChart = ({chartData}) => {
  // Use useState hook to manage state
  const series= [chartData?.gross_profit,chartData?.net_profit,chartData?.sale_qty,chartData?.sale_value,chartData?.total_discount]
  const [labels] = useState(['Gross Profit 1', 'Net Parofit', 'Sale Qty', 'Sale Value4', 'Total Discount']);

  const [options] = useState({
    chart: {
      type: 'donut',  // Donut chart type
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',  // Adjust the donut size
        },
        // Custom labels for each segment
        labels: {
          name: 'Custom Label',  // You can define a label for each pie slice
          value: {
            show: true,  // Whether or not to display the value inside the donut
            fontSize: '14px', // Customize font size of the value
          },
          total: {
            show: true,
            label: 'Total',
            fontSize: '20px',
            fontWeight: 700,
            color: '#373d3f',
            formatter: (w) => {
              return w.globals.seriesTotals.reduce((a, b) => a + b, 0); // Total of the series
            },
          },
        },
      },
    },
    labels: labels,  // Applying custom labels here
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  });
  return (
    <div>
      <div id="chart">
        <ReactApexChart options={options} series={series} type="donut" />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};
export default DonutChart